import Hero from './Hero';
import Stats from './Stats';
import About from './About';
import Why from './Why';
import Orientation from './Orientation';
import Contact from './Contact';

export default function Home() {
  return (
    <main id="top">
      <Hero />
      <Stats />
      <About />
      <Why />
      <Orientation />
      <Contact />
    </main>
  );
}
